<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Post Transplant Details
    </template>
    <template #body>
      <div class="sections">
        <!-- <div class="row">
        <div class="col-4">
          Date of Entry  :
        </div> <div class="col-4">
          <input
            v-model="tglnId"
            class="inputDisplay"
            disabled
          >
        </div>
      </div> -->
    
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="recipientStatus"
              disabled
              label="Recipient Status"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="sourceOfInformation"
              disabled
              label="Source of Information"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="sourceOfInformationOther"
              disabled
              label="Source of Information - Other"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="dateClinicVisit"
              disabled
              label="Date of Clinic Visit or Contact with Source"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="comments"
              class="comments"
              disabled
              label="Comments"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinineUnknown"
              disabled
              label="Serum Creatinine Unknown"
            />
          </div>
        </div>

        <!-- <div class="row">
        <div class="col-4">
          Serum Creatinine  :
        </div> <div class="col-4">
          <input
            v-model="tglnId"
            class="inputDisplay"
            disabled
          >
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          Date of Serum Creatinine  :
        </div> <div class="col-4">
          <input
            v-model="tglnId"
            class="inputDisplay"
            disabled
          >
        </div>
      </div> -->

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="returnedToChronicDialysis"
              disabled
              label="Returned to Chronic Dialysis"
            />
          </div>
          <!-- <div class="col-4">
          <div class="fieldName">
            Returned to Chronic Dialysis
          </div>
          <input
            v-model="returnedToChronicDialysis"
            class="inputDisplay"
            disabled
          >
        </div>  -->


          <div class="col-2">
            <ADSTextInput
              v-model="failureDate"
              disabled
              label="Failure Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinine"
              disabled
              label="Serum Creatinine"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="serumCreatinineDate"
              disabled
              label="Serum Creatinine Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="failureCause"
              disabled
              label="Failure Cause"
            />
          </div>
          <!-- <div class="col-4">
          <div class="fieldName">
            Failure Cause
          </div>
          <input
            v-model="failureCause"
            class="inputDisplay"
            disabled
          >
        </div>  -->

          <div class="col-3">
            <ADSTextInput
              v-model="dateReturnedToChronicDialysis"
              disabled
              label="Date Returned to Chronic Dialysis"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="failureCauseOther"
              disabled
              label="Failure Cause - Other"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="lostFollowUpReason"
              disabled
              label="Lost to Follow-Up Reason"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="deathDate"
              disabled
              label="Death Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="deathDateEstimated"
              disabled
              label="Estimated"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="causeDeathCategory"
              disabled
              label="Cause of Death Category"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="causeDeathType"
              disabled
              label="Cause of Death Type"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="causeDeathTypeOther"
              disabled
              label="Cause of Death Type Other"
            />
          </div>
  
          <div class="col-2">
            <ADSTextInput
              v-model="graftFunctioning"
              disabled
              label="Graft Functioning at Death"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "TransplantSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      recipientStatus: this.getRecipientStatus( this.patientBundle ),
      sourceOfInformation: this.getSourceOfInfo( this.patientBundle ),
      sourceOfInformationOther: this.getSourceOfInfoOther( this.patientBundle ),
      dateClinicVisit: this.getDateClinicVisit( this.patientBundle ),
      comments: this.getComments( this.patientBundle ),
      serumCreatinineUnknown: this.getSerumCreatinineUnknown( this.patientBundle ),
      returnedToChronicDialysis: this.getReturnedToChronicDialysis( this.patientBundle ),
      dateReturnedToChronicDialysis: this.getDateReturnedToChronicDialysis( this.patientBundle ),
      failureDate: this.getFailureDate( this.patientBundle ),
      failureCause: this.getFailureCause( this.patientBundle ),
      failureCauseOther: this.getFailureCauseOther( this.patientBundle ),
      lostFollowUpReason: this.getLostFollowUpReason( this.patientBundle ),
      deathDate: this.getDeathDate( this.patientBundle ),
      deathDateEstimated: this.getDeathDateEstimated( this.patientBundle ),
      causeDeathCategory: this.getCauseDeathCategory( this.patientBundle ),
      causeDeathType: this.getCauseDeathType( this.patientBundle ),
      serumCreatinine: this.getSerumCreatinine( this.patientBundle )?.toString(),
      serumCreatinineDate: this.getSerumCreatinineDate( this.patientBundle )?.substring( 0,10 ),
      causeDeathTypeOther: this.getCauseDeathTypeOther( this.patientBundle ),
      graftFunctioning: this.getGraftFunctioning( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getRecipientStatus( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let recipientStatus = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#377' ) ) ;
      if( recipientStatus && recipientStatus[ 0 ] ) {
        return _.get( recipientStatus[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getSourceOfInfo( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let sourceOfInformation = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#309' ) ) ;
      if( sourceOfInformation && sourceOfInformation[ 0 ] ) {
        return _.get( sourceOfInformation[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getSourceOfInfoOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let sourceOfInformation = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#315' ) ) ;
      if( sourceOfInformation && sourceOfInformation[ 0 ] ) {
        return _.get( sourceOfInformation[0], 'resource.component[0].valueString' );
      } 
      }
    },
    containsCreatinine( observation ) {
       const data = observation.resource?.code?.coding?.filter( ( item ) => item.code === '14682-9' );
       if( data && data.length > 0 )
       return true;
      },
    getSerumCreatinine( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'laboratory' ) );
      if( observation && observation[ 0 ] ) {
      let serumCreatinine = observation[ 0 ].filter( ( n ) => ( this.containsCreatinine( n ) ) ) ;
      if( serumCreatinine && serumCreatinine[ 0 ] ) {
        return _.get( serumCreatinine[ 0 ], 'resource.valueQuantity.value' );
      } 
      }
    },
    getSerumCreatinineDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'laboratory' ) );
      if( observation && observation[ 0 ] ) {
      let serumCreatinineDate = observation[ 0 ].filter( ( n ) => ( this.containsCreatinine( n ) ) ) ;
      if( serumCreatinineDate && serumCreatinineDate[ 0 ] ) {
        return _.get( serumCreatinineDate[ 0 ], 'resource.issued' );
      } 
      }
    },
    getDateClinicVisit( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let dateClinicVisit = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#314' ) ) ;
      if( dateClinicVisit&& dateClinicVisit[ 0 ] ) {
        return _.get( dateClinicVisit[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let comments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#328' ) ) ;
      if( comments && comments[ 0 ] ) {
        return _.get( comments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getSerumCreatinineUnknown( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let serumCreatinineUnknown = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#329' ) ) ;
      if( serumCreatinineUnknown && serumCreatinineUnknown[ 0 ] ) {
        return _.get( serumCreatinineUnknown[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';  
      } 
      }
    },
    getReturnedToChronicDialysis( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let returnedToChronicDialysis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#316' ) ) ;
      if( returnedToChronicDialysis && returnedToChronicDialysis[ 0 ] ) {
        return _.get( returnedToChronicDialysis[0], 'resource.component[0].valueBoolean' ) ? 'Checked' : 'Unchecked';  
      } 
      }
    },
    getDateReturnedToChronicDialysis( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let dateReturnedToChronicDialysis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#317' ) ) ;
      if( dateReturnedToChronicDialysis && dateReturnedToChronicDialysis[ 0 ] ) {
        return _.get( dateReturnedToChronicDialysis[0], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getFailureDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let failureDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#378' ) ) ;
      if( failureDate && failureDate[ 0 ] ) {
        return _.get( failureDate[0], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getFailureCause( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let failureCause = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#379' ) ) ;
      if( failureCause && failureCause[ 0 ] ) {
        return _.get( failureCause[0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getFailureCauseOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let failureCauseOther = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#380' ) ) ;
      if( failureCauseOther && failureCauseOther[ 0 ] ) {
        return _.get( failureCauseOther[0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getLostFollowUpReason( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let lostFollowUpReason = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#319' ) ) ;
      if( lostFollowUpReason && lostFollowUpReason[ 0 ] ) {
        return _.get( lostFollowUpReason[0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getDeathDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let deathDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#381' ) ) ;
      if( deathDate && deathDate[ 0 ] ) {
        return _.get( deathDate[0], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getDeathDateEstimated( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let deathDateEstimated = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#325' ) ) ;
      if( deathDateEstimated && deathDateEstimated[ 0 ] ) {
        return _.get( deathDateEstimated[0], 'resource.component[0].valueBoolean' ); 
      } 
      }
    },
    getCauseDeathCategory( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let causeDeathCategory = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#383' ) ) ;
      if( causeDeathCategory && causeDeathCategory [ 0 ] ) {
        return _.get( causeDeathCategory [0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getCauseDeathType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let causeDeathType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#384' ) ) ;
      if( causeDeathType && causeDeathType [ 0 ] ) {
        return _.get( causeDeathType [0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getCauseDeathTypeOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let causeDeathTypeOther = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#386' ) ) ;
      if( causeDeathTypeOther && causeDeathTypeOther [ 0 ] ) {
        return _.get( causeDeathTypeOther [0], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getGraftFunctioning( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let graftFunctioning = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#326' ) ) ;
      if( graftFunctioning && graftFunctioning [ 0 ] ) {
        return _.get( graftFunctioning[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 740px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 740px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
width: 320px;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.comments .afflo-ds-form-control) {
  width: 330px;
}

</style>
